const STORAGE_KEYS = {
  LOCALE: 'LOCALE',
  servingToken: 'SERVING_TOKEN',
  theme: 'theme',
  USER_NAME: 'USER_NAME',
  SERVING_SESSION_ID: 'SERVING_SESSION_ID',
  NUMBER_OF_PEOPLE: 'NUMBER_OF_PEOPLE',
  TYPE_LAYOUT_FOOD_COURT: 'TYPE_LAYOUT_FOOD_COURT',
  INDEX_RESTAURANT_FOOD_COURT: 'INDEX_RESTAURANT_FOOD_COURT',
  OFFSET_Y_FOOD_COURT: 'OFFSET_Y_FOOD_COURT',
  HAS_SHOWN_POPUP_START_BUFFET: 'HAS_SHOWN_POPUP_START_BUFFET', // Biến để kiểm tra đã hiển thị popup start buffet
  BUFFET_DATA: 'BUFFET_DATA',
  ADD_FRIEND_LINE: 'ADD_FRIEND_LINE',
}
export default STORAGE_KEYS

export const test = () => {}
